import { defineStore } from 'pinia'
import kubakDarkJson from '@/static/kubak_dark.json'
import { ref } from 'vue'

export const useMapStore = defineStore('mapStore', () => {
  const lightLayer = 'https://tiles.b.trytiptop.app/styles/bright/style.json'
  const darkLayer = kubakDarkJson
  const currentTileLayer = ref(localStorage.getItem('themeClass') ? darkLayer : lightLayer)

  function changeCurrentTheme() {
    currentTileLayer.value = localStorage.getItem('themeClass') ? darkLayer : lightLayer
  }

  return {
    changeCurrentTheme,
    currentTileLayer
  }
})
